import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { getKey } from './AddTranslationUI'
import DialogWrapper from '../../../../components/core-ui/DialogWrapper'
import { toast } from 'react-toastify'
import { serverActionService } from '../../../../services/serverActionService'
import { useAuthContext } from '../../../../hooks/useAuthContext'

const SetupInboundTranslation = ({ fields, open, onClose }) => {
  const { user } = useAuthContext()
  const [fieldKeyPair, setFieldKeyPair] = useState([])
  const [exceptions, setExceptions] = useState({})

  useEffect(() => {
    setFieldKeyPair(
      fields.map((it) => {
        return {
          key: it.key ? it.key : getKey(it.field_template_name),
          field_template_id: it.field_template_id,
          field_template_name: it.field_template_name,
        }
      })
    )
  }, [fields])

  const saveChanges = async () => {
    try {
      // await saveChanges
      const res = await serverActionService.saveInboundActionTranslations(user, fieldKeyPair)
      setExceptions(res.exceptions)
      toast.success(`Key changes saved successfully!`)
    } catch (error) {
      toast.error(`Something went wrong!`)
    }
  }

  return (
    <DialogWrapper actions={null} open={open} onClose={onClose} fullWidth>
      <Box style={{ marginTop: 16 }}>
        <Typography variant="h6" fontWeight="bold">
          Setup Inbound Keys
        </Typography>
        <TableContainer style={{ marginTop: 16, marginBottom: 8 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Field</TableCell>
                <TableCell>Key</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {fieldKeyPair.map((pair) => {
                return (
                  <Tooltip title={exceptions[pair.field_template_id]}>
                    <TableRow
                      style={{ background: exceptions[pair.field_template_id] ? '#ffb0b8' : null }}
                    >
                      <TableCell>{pair.field_template_name}</TableCell>
                      <TableCell style={{ padding: 4 }}>
                        <TextField
                          fullWidth
                          size="small"
                          value={pair.key}
                          onChange={(e) => {
                            setFieldKeyPair(
                              fieldKeyPair.map((it) => {
                                return it.field_template_id == pair.field_template_id
                                  ? { ...pair, key: e.target.value }
                                  : it
                              })
                            )
                          }}
                        ></TextField>
                      </TableCell>
                    </TableRow>
                  </Tooltip>
                )
              })}
              <TableRow></TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Button
          size="small"
          onClick={saveChanges}
          color="primary"
          variant="contained"
          style={{ marginTop: 16 }}
        >
          Save Changes
        </Button>
      </Box>
    </DialogWrapper>
  )
}

export default SetupInboundTranslation
